<template>
  <v-chip
    v-if="status"
    :color="color"
    :small="!xSmall"
    :x-small="xSmall"
    text-color="white"
    v-bind="$attrs"
    v-on="$listeners"
  >
    {{ $t(`sites.work_statuses.${status}`) }}
  </v-chip>
</template>

<script>
const COLORS = { NOTSTARTED: 'blue-grey', INPROGRESS: 'orange', DONE: 'green' };

export default {
  name: 'WorkStatusChip',
  inheritAttrs: false,
  props: {
    status: { type: String, default: null },
    xSmall: { type: Boolean, default: false },
  },
  computed: {
    color() {
      return COLORS[this.status] || 'grey';
    },
  },
};
</script>
